<script>
  import { onDestroy } from "svelte";

  export let title;

  onDestroy(() => {
    document.title = "Provi";
  });
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>
